import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../components/form/input/InputField";
import Label from "../../components/form/Label";
import PageMeta from "../../components/common/PageMeta";
import { Key } from "lucide-react";
import {
  forgotPasswordContainer,
  formContainer,
  iconContainer,
  keyIcon,
  titleContainer,
  heading,
  subText,
  inputField,
  loginButton,
  passwordRememberContainer,
  forgotPassword,
  errorText,
} from "../../styles/pages/ForgotPassword.Styles";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const baseurl = "https://salesbox.oteqprojects.co.in/";

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setError("");
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");

    if (!email.trim()) {
      setError("The email field is required.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/forgot/password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, baseurl }),
        }
      );

      const data = await response.json();

      if (data.status === 200) {
        navigate("/check-email", { state: { email } });
      } else {
        setError(
          data.message?.email?.[0] || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      setError("Failed to send request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageMeta
        title="Forgot Password"
        description="This is the Forgot Password page"
      />

      <div className={forgotPasswordContainer}>
        <div className={formContainer}>
          {/* Key Icon */}
          <div className={iconContainer}>
            <Key className={keyIcon} />
          </div>

          <div className={titleContainer}>
            <h1 className={heading}>Forgot Your Password?</h1>
            <p className={subText}>
              Enter the email address linked to your account, and we’ll send you
              a link to reset your password.
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div>
              <div>
                <Label>
                  Email <span className="text-error-500">*</span>
                </Label>
                <Input
                  className={`${inputField} ${error ? "border-red-400 ring-2 ring-red-500/10 dark:border-red-400 dark:ring-2 dark:ring-red-500/10" : ""}`}
                  value={email}
                  onChange={handleEmailChange}
                />

                {error && <p className={errorText}>{error}</p>}
              </div>

              <div>
                <button
                  type="submit"
                  className={loginButton}
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Reset Link"}
                </button>
              </div>

              <div className={passwordRememberContainer}>
                <p>Wait, I remember my password...</p>
                <button
                  type="button"
                  onClick={() => navigate("/signin")}
                  className={forgotPassword}
                >
                  Click here
                </button>

              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;